import {ApplicationIds, IAppConfig} from "ngx-heka-design-lib";

export interface IAppConfigExtended extends IAppConfig {
  translationContent: string;
}


export const APP_CONFIGS: IAppConfigExtended[] = [
  {
    appId: ApplicationIds.CUSTOMER_PORTAL,
    translationTitle: 'APPS.CUSTOMER_PORTAL.TITLE',
    translationContent: 'APPS.CUSTOMER_PORTAL.DESCRIPTION',
    isCurrentApp: false,
    order: 0,
    imgUrl: 'assets/images/heka-logo-symbols/hplus.svg'
  },
  {
    appId: ApplicationIds.HPLUS_SERVICE,
    translationTitle: 'APPS.SERVICE.TITLE',
    translationContent: 'APPS.SERVICE.DESCRIPTION',
    isCurrentApp: false,
    order: 1,
    imgUrl: 'assets/images/heka-logo-symbols/office.svg'
  },
  {
    appId: ApplicationIds.B2B_ONLINE,
    translationTitle: 'APPS.B2B_ONLINE.TITLE',
    translationContent: 'APPS.B2B_ONLINE.DESCRIPTION',
    isCurrentApp: false,
    order: 2,
    imgUrl: 'assets/images/heka-logo-symbols/b2b_online.svg'
  },
  {
    appId: ApplicationIds.OPERATOR,
    translationTitle: 'APPS.OPERATOR.TITLE',
    translationContent: 'APPS.OPERATOR.DESCRIPTION',
    isCurrentApp: false,
    order: 3,
    imgUrl: 'assets/images/heka-logo-symbols/operator.svg'
  },
  {
    appId: ApplicationIds.ELECTRICITY_CALCULATION_TOOL,
    translationTitle: 'APPS.ELECTRICITY_CALCULATION_TOOL.TITLE',
    translationContent: 'APPS.ELECTRICITY_CALCULATION_TOOL.DESCRIPTION',
    isCurrentApp: false,
    order: 4,
    imgUrl: 'assets/images/heka-logo-symbols/e_calc_tool.svg'
  },
  {
    appId: ApplicationIds.TENDER_TOOL,
    translationTitle: 'APPS.TENDER_TOOL.TITLE',
    translationContent: 'APPS.TENDER_TOOL.DESCRIPTION',
    isCurrentApp: false,
    order: 5,
    imgUrl: 'assets/images/heka-logo-symbols/tender_tool.svg'
  },
  {
    appId: ApplicationIds.LEVEL_2,
    translationTitle: 'APPS.LEVEL_2.TITLE',
    translationContent: 'APPS.LEVEL_2.DESCRIPTION',
    isCurrentApp: true,
    order: 6,
    imgUrl: 'assets/images/heka-logo-symbols/hplus.svg'
  },
  {
    appId: ApplicationIds.HPLUS_DONGLE,
    translationTitle: 'APPS.HPLUS_DONGLE.TITLE',
    translationContent: 'APPS.HPLUS_DONGLE.DESCRIPTION',
    isCurrentApp: false,
    order: 7,
    imgUrl: 'assets/images/heka-logo-symbols/dongle.svg'
  },
  {
    appId: ApplicationIds.HPLUS_DONGLE_ADMIN,
    translationTitle: 'APPS.HPLUS_DONGLE_ADMIN.TITLE',
    translationContent: 'APPS.HPLUS_DONGLE_ADMIN.DESCRIPTION',
    isCurrentApp: false,
    order: 8,
    imgUrl: 'assets/images/heka-logo-symbols/dongle_admin.svg'
  },
  {
    appId: ApplicationIds.REMOTE_ADMIN,
    translationTitle: 'APPS.REMOTE_ADMIN.TITLE',
    translationContent: 'APPS.REMOTE_ADMIN.DESCRIPTION',
    isCurrentApp: false,
    order: 9,
    imgUrl: 'assets/images/heka-logo-symbols/remote_desktop.svg'
  },
  {
    appId: ApplicationIds.REMOTE_DESKTOP,
    translationTitle: 'APPS.REMOTE_DESKTOP.TITLE',
    translationContent: 'APPS.REMOTE_DESKTOP.DESCRIPTION',
    isCurrentApp: false,
    order: 10,
    imgUrl: 'assets/images/heka-logo-symbols/remote_desktop.svg'
  },
  {
    appId: ApplicationIds.OMS_TOOL,
    translationTitle: 'APPS.OMS_TOOL.TITLE',
    translationContent: 'APPS.OMS_TOOL.DESCRIPTION',
    isCurrentApp: false,
    order: 11,
    imgUrl: 'assets/images/heka-logo-symbols/oms.svg'
  },
  {
    appId: ApplicationIds.STATUS,
    translationTitle: 'APPS.STATUS.TITLE',
    translationContent: 'APPS.STATUS.DESCRIPTION',
    isCurrentApp: false,
    order: 12,
    imgUrl: 'assets/images/heka-logo-symbols/status.svg'
  },
  {
    appId: ApplicationIds.GO_APP_ADMIN,
    translationTitle: 'APPS.GO_APP_ADMIN.TITLE',
    translationContent: 'APPS.GO_APP_ADMIN.DESCRIPTION',
    isCurrentApp: false,
    order: 13,
    imgUrl: 'assets/images/heka-logo-symbols/go_app.svg'
  },
  {
    appId: ApplicationIds.GO_APP_MOBILE,
    translationTitle: 'APPS.GO_APP_MOBILE.TITLE',
    translationContent: 'APPS.GO_APP_MOBILE.DESCRIPTION',
    isCurrentApp: false,
    order: 14,
    imgUrl: 'assets/images/heka-logo-symbols/go_app.svg'
  },
  {
    appId: ApplicationIds.LEARN_WORLD,
    translationTitle: 'APPS.LEARN_WORLD.TITLE',
    translationContent: 'APPS.LEARN_WORLD.DESCRIPTION',
    isCurrentApp: false,
    order: 15,
    imgUrl: 'assets/images/heka-logo-symbols/learn_world.svg'
  },
  {
    appId: ApplicationIds.AI_PLAN,
    translationTitle: 'APPS.AI_PLAN.TITLE',
    translationContent: 'APPS.AI_PLAN.DESCRIPTION',
    isCurrentApp: false,
    order: 16,
    imgUrl: 'assets/images/heka-logo-symbols/ai_plan.svg'
  }
];
